<template>
    <div class="release-feature">
        <div class="release-feature-image-wrapper">
            <div class="release-feature-image">
                <video v-if="feature.is_video" ref="videoPlayer" height="190" width="190" muted="muted">
                    <source :src="feature.src" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <img v-else :src="feature.src" alt="" />
            </div>
        </div>

        <slot></slot>

        <!-- eslint-disable vue/no-v-html -->
        <h2 class="release-feature-title" v-html="feature.title"></h2>
        <!-- eslint-disable vue/no-v-html -->
        <p class="release-feature-content" v-html="feature.content"></p>
    </div>
</template>

<script setup>
    import { ref, onMounted, inject, watch } from 'vue';
    // eslint-disable-next-line no-unused-vars
    const props = defineProps({
        feature: {
            type: Object,
        },
    });

    const featureChanged = inject('featureChanged');

    const videoPlayer = ref(null);

    onMounted(() => {
        playVideo();
    });

    function playVideo() {
        if (videoPlayer.value) {
            videoPlayer.value.currentTime = 0; // Set current time to 0 (first second)
            videoPlayer.value.play();
        }
    }

    watch(featureChanged, (oldValue, newValue) => {
        if (oldValue !== newValue) {
            playVideo();
        }
    });
</script>
